import * as types from './types';

function markAsNewAccount(data) {
    return {
        type: types.MARK_AS_NEW_ACCOUNT,
    };
}

function setLoggedIn(data) {
    return {
        type: types.SET_LOGGED_IN,
        payload: data,
    };
}

function setLoggedOut() {
    return {
        type: types.SET_LOGGED_OUT,
    };
}

function updateBillingAddress(data) {
    return {
        type: types.UPDATE_BILLING_ADDRESS,
        payload: data,
    };
}

function updateUserName(data) {
    return {
        type: types.UPDATE_USER_NAME,
        payload: data,
    };
}

function setUserOrders(data) {
    return {
        type: types.SET_USER_ORDERS,
        payload: data,
    };
}

function setTicketDownloadUrl(data) {
    return {
        type: types.SET_TICKET_DOWNLOAD_URL,
        payload: data,
    };
}

function updateUserOrder(data) {
    return {
        type: types.UPDATE_USER_ORDER,
        payload: data,
    };
}

export {
    markAsNewAccount,
    setLoggedIn,
    setLoggedOut,
    setTicketDownloadUrl,
    setUserOrders,
    updateBillingAddress,
    updateUserName,
    updateUserOrder,
};
